// extracted by mini-css-extract-plugin
module.exports = {"Mask":"BobLoadingMask_Mask__EFylD","IconContainer":"BobLoadingMask_IconContainer__1Jr_y","Color":"BobLoadingMask_Color__3MW7u"};